import messages from '../../../../locale/messages';

const requiredFields = [
    'heroBadge',
    'heroTitle',
    'heroSubtitle',
    'heroDescription',
    'feature1Title',
    'feature1Description',
    'feature2Title',
    'feature2Description',
    'feature3Title',
    'feature3Description',
    'bottomCardTitle',
    'bottomCardText',
];

const validate = values => {
    const errors = {};

    requiredFields.forEach(field => {
        if (!values[field] || !String(values[field]).trim()) {
            errors[field] = messages.required;
        }
    });

    return errors;
};

export default validate;
